import { useContext } from 'react';
import { SystemContext } from '../System';
import { OrgStore } from '../stores/OrgStore';

export function useOrgStore(): OrgStore {
  const system = useContext(SystemContext);
  return system.orgStore;
}
